<template>
    <div class="newsreport-wrap">
        <div class="title"><img src="./images/icon05.png" /> 报警记录</div>
        <div class="news_list">
            <ul>
                <li v-for="(item,index) in almMsg.slice(0,3)" :key="index" class="li02">
                {{ item.msg }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name:"newsreport",
    data(){
        return {
             almMsg:[
                {msg:"天地一号气压过高报警"},
                {msg:"美心食品气压过高报警"},
                {msg:"顶益2温度过低"},
            ],
        }
    }
}
</script>

<style lang="scss">
.newsreport-wrap{
    width:100%;
    height: 100%;

    .news_list{
        padding: 10px; 
        font-size: 16px; 
        overflow: hidden;}
    .news_list ul{
        list-style: none;
    }
    .news_list ul li{
        line-height: 30px;
        padding-left: 15px;
    }
    .li01{
        background: url(./images/new_list01.png) left center no-repeat;
    }
    .li02{
        background: url(./images/new_list02.png) left center no-repeat; 
        color: #FF0000;
    }
}
</style>